var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-confirm-dialog',{attrs:{"is-open":_vm.isOpen,"title":_vm.dialogTitle,"message":_vm.dialogMessage,"confirm-label":_vm.$t('funnel.lockUnlock.confirm'),"cancel-label":_vm.$t('funnel.lockUnlock.cancel')},on:{"cancel":_vm.closeLockUnlockCampaignModal,"confirm":_vm.toggleLock}})
}
var staticRenderFns = []

export { render, staticRenderFns }